import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { startListApi } from '../startListApi';
import type { CreateStartListGroupRequest } from '../../types/startList';

export const startListGroupsQueryKey = (disciplineId: number) =>
  ['start-list-groups', disciplineId] as const;

export const useStartListGroups = (disciplineId: number) =>
  useQuery({
    queryKey: startListGroupsQueryKey(disciplineId),
    queryFn: () => startListApi.findByDiscipline(disciplineId),
    enabled: !!disciplineId,
  });

export const useCreateStartListGroup = (disciplineId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (req: CreateStartListGroupRequest) =>
      startListApi.create(disciplineId, req),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: startListGroupsQueryKey(disciplineId) });
    },
  });
};

export const useUpdateStartListGroup = (disciplineId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, req }: { id: number; req: CreateStartListGroupRequest }) =>
      startListApi.update(id, req),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: startListGroupsQueryKey(disciplineId) });
    },
  });
};

export const useDeleteStartListGroup = (disciplineId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => startListApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: startListGroupsQueryKey(disciplineId) });
    },
  });
};

export const useResetStartListGroupsFromTemplate = (disciplineId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => startListApi.resetFromTemplate(disciplineId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: startListGroupsQueryKey(disciplineId) });
    },
  });
};
